const KEY = "localpdf-prefs";

export type LocalPrefs = {
  rememberSession: boolean;
  reducedMotion: boolean;
};

const defaults: LocalPrefs = { rememberSession: true, reducedMotion: false };

export function loadPrefs(): LocalPrefs {
  try {
    return { ...defaults, ...(JSON.parse(localStorage.getItem(KEY) || "{}") as Partial<LocalPrefs>) };
  } catch {
    return defaults;
  }
}

export function savePrefs(prefs: LocalPrefs) {
  localStorage.setItem(KEY, JSON.stringify(prefs));
  document.documentElement.classList.toggle("reduce-motion", prefs.reducedMotion);
}

export function applyPrefs() {
  const prefs = loadPrefs();
  document.documentElement.classList.toggle("reduce-motion", prefs.reducedMotion);
  return prefs;
}
